/**
 * OTURUM JETONUNUN YENİLENMESİ — istemci katmanının tek kancası
 * (işlevsel düzeltme turu).
 *
 * **BELİRTİ:** sayfa bir süre açık kalınca istekler 401 dönüyor, API
 * loglarında `exp claim timestamp check failed` birikiyordu.
 *
 * **SEBEP İKİ KATLIYDI:**
 *  1. `automaticSilentRenew` AÇIKTI ve jeton arka planda gerçekten
 *     yenileniyordu — ama `useAuth` yalnız AÇILIŞTA okuyordu; React durumu
 *     (ve `AccessTokenContext`) **ilk jetonda donuyordu**. Yenilenen jeton
 *     depoda duruyor, isteklere **eski jeton** gidiyordu.
 *  2. Yenileme hiç koşmadığı ya da geciktiği durumda istemcinin **son çaresi
 *     yoktu**: 401 doğrudan ekrana hata olarak düşüyordu.
 *
 * **ÇÖZÜM İKİ KATMANLI:** (a) sessiz yenileme artık ekrana BAĞLANIR
 * (`use-auth.ts` olay aboneliği), (b) buna rağmen 401 gelirse istek BİR KEZ
 * yenilenip tekrar denenir (`api/client.ts`).
 *
 * ⚠️ **BU MODÜL OIDC KÜTÜPHANESİNİ BİLMEZ.** Yenileyiciyi kimlik katmanı
 * kaydeder; `api/client.ts` yalnız "yenile" der. Böylece istek katmanı
 * oturum katmanına bağımlı olmaz (public rotalarda kimlik kodu HİÇ mount
 * edilmiyor — App.tsx'teki Kapı 2 kararı bozulmasın).
 */

type Yenileyici = () => Promise<string | null>;

let yenileyici: Yenileyici | null = null;
/** Uçuştaki yenileme — N eşzamanlı 401 tek yenilemeye biner. */
let ucustaki: Promise<string | null> | null = null;

export function tokenYenileyiciAta(fn: Yenileyici | null): void {
  yenileyici = fn;
}

/**
 * Jetonu yeniler; başarısızsa `null` döner (fırlatmaz — çağıran 401'i
 * kendi hatasıyla göstersin diye).
 *
 * ⚠️ Eşzamanlı çağrılar TEK yenilemeyi paylaşır: bir ekranda on sorgu aynı
 * anda 401 alırsa Keycloak'a on refresh isteği gitmez (brute-force
 * korumasını tetiklerdi — Playwright `workers: 1` dersinin aynısı).
 */
export function tokenYenile(): Promise<string | null> {
  if (!yenileyici) return Promise.resolve(null);
  ucustaki ??= yenileyici()
    .catch(() => null)
    .finally(() => {
      ucustaki = null;
    });
  return ucustaki;
}
